module.exports = __webpack_public_path__ + "img/us3.6641711f.jpg";